export const assessmentTemplate = [
  {
    _id: "0005",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "AAronKrunk",
      createdDate: "2022-03-04T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "gad7",
      omniTypeVersion: 1,
      title: "GAD-7",
      description: "",
      duration: "About 5 minutes",
      directions: null,
      attribution: null,
      validated: null,
      selfAssessment: false,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "GAD71",
          numberText: "1",
          text: "This question hasn't happened yet",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: null,
          answerOptions: [
            {
              value: "0",
              text: "TBD",
              displayType: "To Be Determined",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: {
        finalResult: null,
      },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "gad7",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
